import apiClient from './apiClient';

// ========== Types ==========
// バックエンド実レスポンス（MonthlyDailyShiftSlotsOutput / DayShiftSlotsOutput）に準拠

/**
 * 時間帯ごとのシフト枠情報
 * @description 1日の中の募集枠（時間帯）の詳細情報
 */
export interface DailySlotTimeInfo {
  /** シフト枠ID */
  id: number;
  /** 開始時刻（HH:mm形式） */
  startTime: string;
  /** 終了時刻（HH:mm形式） */
  endTime: string;
  /** 募集枠数 */
  recruitmentSlots: number;
  /** 応募済み数 */
  recruitedSlots: number;
  /** 予約枠合計 */
  totalReservationSlots: number;
  /** 緊急枠数 */
  urgentSlots: number;
  /** 確定済み数 */
  confirmedSlots: number;
  /** 不足数 */
  shortageSlots: number;
}

/**
 * 日別シフト枠情報
 * @description 1日分のシフト枠（募集枠）情報
 */
export interface DayShiftSlots {
  /** 日付（YYYY-MM-DD形式） */
  date: string;
  /** 祝日フラグ */
  isHoliday: boolean;
  /** 祝日名 */
  holidayName: string | null;
  /** 曜日（0=日曜〜6=土曜） */
  dayOfWeek: number;
  /** 日別ステータス */
  status: string;
  /** 時間帯ごとのシフト枠配列 */
  slots: DailySlotTimeInfo[];
}

/**
 * 月次日別シフト枠データ
 * @description 月次メタデータ + 日付ごとの募集枠
 */
export interface MonthlyDailyShiftSlots {
  /** 対象年 */
  year: number;
  /** 対象月（1-12） */
  month: number;
  /** 月次ステータス（draft/fixed_recruiting/fixed_closed/fixed_confirmed/recruiting/closed/confirmed） */
  status: string;
  /** 募集開始日時（ISO 8601形式、未設定時はnull） */
  recruitmentStartAt: string | null;
  /** 募集締切日時（ISO 8601形式、未設定時はnull） */
  deadlineAt: string | null;
  /** 日付ごとのシフト枠配列 */
  days: DayShiftSlots[];
}

/**
 * 日別シフト枠取得レスポンス
 * @endpoint GET /api/daily-shift-slots?year={year}&month={month}
 */
export interface FetchDailyShiftSlotsResponse {
  /** 成功フラグ */
  success: boolean;
  /** レスポンスデータ */
  data: MonthlyDailyShiftSlots;
}

// ========== API Functions ==========

/**
 * 日別シフト枠情報を取得
 * @param year - 対象年（YYYY形式）
 * @param month - 対象月（1-12）
 * @returns 月次日別シフト枠情報
 * @endpoint GET /api/daily-shift-slots?year={year}&month={month}
 */
export const fetchDailyShiftSlots = async (
  year: number,
  month: number
): Promise<FetchDailyShiftSlotsResponse> => {
  const response = await apiClient.get<FetchDailyShiftSlotsResponse>(
    `/api/daily-shift-slots`,
    {
      params: { year, month },
    }
  );
  return response.data;
};

// dailyShiftSlotsApi オブジェクトとしてもエクスポート
export const dailyShiftSlotsApi = {
  fetchDailyShiftSlots,
};

export default dailyShiftSlotsApi;
